/* eslint-disable */
import listing from "@/apollo/cruises/bookings/listing.gql";
import revised_hold_time from "@/apollo/cruises/bookings/revised_hold_time.gql";
import update_dpt_number from "@/apollo/cruises/bookings/update_dpt_number.gql";
import update_payments from "@/apollo/cruises/bookings/update_payments.gql";

export const state = () => ({ list: [], loading: false });

export const mutations = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 04 Mar 2025 | 05:12PM
   * @param {*} state
   * @param {*} value
   */
  setListing: (state, value) => (state.list = value),

  /**
   * @description
   * @author Saurabh Jangra
   * @date 04 Mar 2025 | 05:12PM
   * @param {*} state
   * @param {*} value
   */
  setLoading: (state, value) => (state.loading = value)
};

export const actions = {
  /**
   * @description
   * @author Saurabh Jangra
   * @date 04 Mar 2025 | 05:49PM
   * @param {*} { commit }
   * @returns {*}
   */
  fetchListing({ commit }) {
    commit("setLoading", true);
    commit("setListing", []);
    return new Promise((resolve) => {
      this.$apolloClient
        .query({ query: listing })
        .then(({ data }) => {
          commit("setListing", data.cruise_inventory_booking_reports);
          resolve(data.cruise_inventory_booking_reports);
          commit("setLoading", false);
        })
        .catch((err) => {
          commit("setLoading", false);
        });
    });
  },

  /**
   * @description
   * @author Saurabh Jangra
   * @date 05 Mar 2025 | 04:50PM
   * @param {*} __
   * @param {*} payload
   * @returns {*}
   */
  revisedHoldTime(__, payload) {
    return new Promise(async (resolve) => {
      const {
        data: { cruise_revised_hold_time }
      } = await this.$apolloClient.mutate({ mutation: revised_hold_time, variables: { payload } });
      resolve(cruise_revised_hold_time);
    });
  },

  /**
   * @description
   * @author Saurabh Jangra
   * @date 06 Mar 2025 | 12:25PM
   * @param {*} __
   * @param {*} payload
   * @returns {*}
   */
  updateDptNumber(__, payload) {
    return new Promise(async (resolve) => {
      const {
        data: { cruise_update_booking_dpt_details }
      } = await this.$apolloClient.mutate({ mutation: update_dpt_number, variables: { payload } });
      resolve(cruise_update_booking_dpt_details);
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 20 Mar 2025 | 04:36PM
   * @param {*} __
   * @param {*} payload
   * @returns {*}
   */
  updatePayments(__, payload) {
    return new Promise(async (resolve) => {
      const {
        data: { cruise_update_booking_payments }
      } = await this.$apolloClient.mutate({ mutation: update_payments, variables: { payload } });
      resolve(cruise_update_booking_payments);
    });
  },
  /**
   * @description
   * @author Saurabh Jangra
   * @date 04 Mar 2025 | 05:48PM
   * @param {*} { commit }
   * @returns {*}
   */
  refresh({ commit }) {
    return new Promise(async (resolve) => {
      const _result = this.$subscribeClient.iterate({
        query: `subscription { refresh_cruises_inventory_bookings }`
      });
      for await (const event of _result) {
        commit("setLoading", true);
        this.$apolloClient.query({ query: listing }).then(({ data }) => {
          commit("setListing", data.cruise_inventory_booking_reports);
          commit("setLoading", false);
          resolve(data.cruise_inventory_booking_reports);
        });
      }
    });
  }
};

export const getters = {
  list: (state) => state.list,
  loading: (state) => state.loading
};
